import React from "react";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import {
  Comparator,
  numberFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../services/CamplaCoreService";
import CreateModuleClassDialog from "./dialogs/createModuleClassDialog/CreateModuleClassDialog";
import Button from "react-bootstrap/Button";
import UpdateModuleClassDialog from "./dialogs/updateModuleClassDialog/UpdateModuleClassDialog";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import ModuleClassActionCell from "./moduleClassActionCell/ModuleClassActionCell";
import StorageService from "../../services/StorageService";

import {
  ButtonGroup,
  Col,
  Container,
  Row,
  ToggleButton,
} from "react-bootstrap";
import { Translation, withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import DeleteDialog from "../../components/dialogs/deleteDialog/DeleteDialog";

class ModuleClasses extends React.Component {
  tableId = "moduleClassesTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.getTableConfigValue(
      this.tableId,
      "showFilters"
    );
    this.state = {
      moduleClasses: [],
      classOptions: [],
      moduleOptions: [],
      classesMap: new Map(),
      modulesMap: new Map(),
      usersMap: new Map(),
      showCreateModal: false,
      showDeleteSelectedModal: false,
      showDeleteModal: false,
      showUpdateModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      moduleClassToDeleteOrEdit: null,
      selectedModuleClasses: [],
      errorMessage: "",
      columns: [],
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
    };
    this.loadData = this.loadData.bind(this);
    this.loadCachedData = this.loadCachedData.bind(this);
    this.extendedModuleClass = this.extendedModuleClass.bind(this);
    this.handleCreateModuleClass = this.handleCreateModuleClass.bind(this);
    this.handleUpdateModuleClass = this.handleUpdateModuleClass.bind(this);
    this.handleDeleteModuleClass = this.handleDeleteModuleClass.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();
    this.loadCachedData();
    this.setState(await this.loadData());
  }

  async handleCreateModuleClass(moduleClassToCreate) {
    try {
      let createdModuleClass = await CamplaCoreService.createModuleClass(
        moduleClassToCreate
      );
      createdModuleClass = this.extendedModuleClass(createdModuleClass);
      createdModuleClass["user"] = StorageService.getUser() ? StorageService.getUser().email : "";
      this.state.moduleClasses.push(createdModuleClass);
      const updatedModuleClasses = [...this.state.moduleClasses];
      StorageService.set("extendedModuleClass", updatedModuleClasses);
      this.setState({
        showCreateModal: false,
        moduleClasses: updatedModuleClasses,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "ModuleClasses.APIError.PreconditionFailed",
            CONFLICT: "ModuleClasses.APIError.CreateConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async handleUpdateModuleClass(changedClass) {
    try {
      let updatedModuleClass = await CamplaCoreService.updateModuleClass(
        this.state.moduleClassToDeleteOrEdit._id,
        changedClass
      );
      updatedModuleClass = this.extendedModuleClass(updatedModuleClass);
      for (const i in this.state.moduleClasses) {
        if (this.state.moduleClasses[i]._id === updatedModuleClass._id) {
          updatedModuleClass["user"] = this.state.moduleClasses[i]["user"];
          this.state.moduleClasses[i] = Object.assign({}, updatedModuleClass);
          break;
        }
      }
      const updatedModuleClasses = [...this.state.moduleClasses];
      StorageService.set("extendedModuleClass", updatedModuleClasses);
      this.setState({
        showUpdateModal: false,
        moduleClasses: updatedModuleClasses,
        moduleClassToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "ModuleClasses.APIError.PreconditionFailed",
            NOT_FOUND: "ModuleClasses.APIError.NotFound",
            CONFLICT: "ModuleClasses.APIError.UpdateConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async handleDeleteModuleClass() {
    try {
      await CamplaCoreService.deleteModuleClass(
        this.state.moduleClassToDeleteOrEdit._id
      );
      const updatedModuleClasses = this.state.moduleClasses.filter(
        (x) => x._id !== this.state.moduleClassToDeleteOrEdit._id
      );
      StorageService.set("extendedModuleClass", updatedModuleClasses);
      this.setState({
        showDeleteModal: false,
        moduleClasses: updatedModuleClasses,
        moduleClassToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "ModuleClasses.APIError.PreconditionFailed",
            NOT_FOUND: "ModuleClasses.APIError.NotFound",
            CONFLICT: "ModuleClasses.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  extendedModuleClass(moduleClass) {
    return Object.assign(moduleClass, {
      moduleName: this.state.modulesMap.has(moduleClass.moduleId)
        ? this.state.modulesMap.get(moduleClass.moduleId).name
        : "",
      className: this.state.classesMap.has(moduleClass.classId)
        ? this.state.classesMap.get(moduleClass.classId).name
        : "",
    });
  }

  loadCachedData() {
    let cachedModuleClasses = StorageService.getReferenceType(
      "extendedModuleClasses"
    );
    if (cachedModuleClasses) {
      const cachedClassesMap = StorageService.getReferenceType(
        "classesMap",
        "map"
      );
      const cachedModulesMap = StorageService.getReferenceType(
        "modulesMap",
        "map"
      );
      const cachedClassOptions = StorageService.getReferenceType(
        "classOptions"
      );
      const cachedModuleOptions = StorageService.getReferenceType(
        "moduleOptions"
      );
      this.setState({
        classesMap: cachedClassesMap || new Map(),
        modulesMap: cachedModulesMap || new Map(),
        classOptions: cachedClassOptions || [],
        moduleOptions: cachedModuleOptions || [],
        moduleClasses: cachedModuleClasses || [],
      });
    }
  }

  async loadData() {
    try {
      const classes = await CamplaCoreService.getAllClasses();
      const modules = await CamplaCoreService.getAllModules();
      let moduleClasses = await CamplaCoreService.getAllModuleClassesWithUsers();
      const classesMap = new Map();
      const modulesMap = new Map();

      classes.forEach((c) => classesMap.set(c._id, c));
      modules.forEach((m) => modulesMap.set(m._id, m));

      this.setState({
        classesMap,
        modulesMap,
      });

      const classOptions = [];
      const moduleOptions = [];
      classesMap.forEach((v, k) =>
        classOptions.push({ value: k, label: v.name })
      );
      modulesMap.forEach((v, k) =>
        moduleOptions.push({ value: k, label: v.name })
      );
      moduleClasses = moduleClasses.map((mc) => this.extendedModuleClass(mc));

      StorageService.set("classesMap", classesMap, "map");
      StorageService.set("modulesMap", modulesMap, "map");
      StorageService.set("extendedModuleClasses", moduleClasses);
      StorageService.set("classOptions", classOptions);
      StorageService.set("moduleOptions", moduleOptions);

      return {
        classOptions,
        moduleOptions,
        moduleClasses,
      };
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
    return {
      classOptions: [],
      moduleOptions: [],
      moduleClasses: {},
    };
  }

  render() {
    const { t } = this.props;

    const columns = [
      {
        dataField: "moduleName",
        text: t("ModuleClasses.ColumnModuleName"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          // placeholder: ' '
        }),
      },
      {
        dataField: "className",
        text: t("ModuleClasses.ColumnClassName"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          // placeholder: ' '
        }),
      },
      {
        dataField: "user",
        text: t("ModuleClasses.ColumnOwner"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "year",
        text: t("ModuleClasses.ColumnYear"),
        sort: true,
        filter: numberFilter({
          comparatorStyle: { display: "none" },
          withoutEmptyComparatorOption: true,
          comparators: [Comparator.EQ],
          style: { display: this.state.displayFilter },
          //  placeholder: ' '
        }),
      },
      {
        dataField: "isFall",
        text: t("ModuleClasses.ColumnIsFall"),
        formatter: this.getIsFallValue,
        sort: true,
        filter: selectFilter({
          options: [
            { value: true, label: "Fall" },
            { value: false, label: "Spring" },
          ],
          style: { display: this.state.displayFilter },
          //  placeholder: ' '
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup toggle style={{ float: "right", marginRight: "-12px" }}>
            <ToggleButton
              type="checkbox"
              value={1}
              className={"btn-green btn-sm"}
              checked={this.state.showFilters}
              onChange={(e) => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none",
                });
                StorageService.setTableConfigValue(
                  this.tableId,
                  "showFilters",
                  e.currentTarget.checked
                );
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, row) => {
          return (
            <ModuleClassActionCell
              onEdit={() =>
                this.setState({
                  showUpdateModal: true,
                  moduleClassToDeleteOrEdit: row,
                })
              }
              onDelete={() =>
                this.setState({
                  showDeleteModal: true,
                  moduleClassToDeleteOrEdit: row,
                })
              }
              class={row}
            />
          );
        },
      },
    ];

    const moduleClassNameToDelete =
      this.state.moduleClassToDeleteOrEdit?.moduleName +
      " - " +
      this.state.moduleClassToDeleteOrEdit?.className +
      " - " +
      (this.state.moduleClassToDeleteOrEdit?.isFall ? "Fall" : "Spring") +
      "/" +
      this.state.moduleClassToDeleteOrEdit?.year;

    return (
      <div>
        <CreateModuleClassDialog
          show={this.state.showCreateModal}
          classes={this.state.classOptions}
          modules={this.state.moduleOptions}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showCreateModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateModuleClass}
          dialogApiError={this.state.dialogApiError}
        />

        <DeleteDialog
          show={this.state.showDeleteModal}
          onHide={() => this.setState({ showDeleteModal: false })}
          onSubmit={this.handleDeleteModuleClass}
          dialogApiError={this.state.dialogApiError}
          title={t("ModuleClasses.ModuleClassModal.DeleteModal.Title")}
          body={t("ModuleClasses.ModuleClassModal.DeleteModal.Text", {
            moduleClassName: moduleClassNameToDelete,
          })}
          rightButtonText={t(
            "ModuleClasses.ModuleClassModal.DeleteModal.Confirm"
          )}
          leftButtonText={t("DialogCancel")}
        />
        <UpdateModuleClassDialog
          show={this.state.showUpdateModal}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showUpdateModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showUpdateModal: false,
              });
            }
          }}
          classes={this.state.classOptions}
          modules={this.state.moduleOptions}
          modulesMap={this.state.modulesMap}
          classesMap={this.state.classesMap}
          onSubmit={this.handleUpdateModuleClass}
          moduleClass={this.state.moduleClassToDeleteOrEdit}
          dialogApiError={this.state.dialogApiError}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />

        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("ModuleClasses.Title")}</h2>
            </Col>
            <Col>
              <Button
                className={"btn-green"}
                style={{ float: "right" }}
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                data={this.state.moduleClasses}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField={"_id"}
                ref={this.paginationTableRef}
                id={this.tableId}
                view="moduleClasses"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      this.setState(() => ({
        selectedModuleClasses: [...this.state.selectedModuleClasses, row._id],
      }));
    } else {
      this.setState(() => ({
        selectedModuleClasses: this.state.selectedModuleClasses.filter(
          (x) => x !== row._id
        ),
      }));
    }
  };

  handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r._id);
    if (isSelect) {
      this.setState(() => ({
        selectedModuleClasses: ids,
      }));
    } else {
      this.setState(() => ({
        selectedModuleClasses: [],
      }));
    }
  };

  getIsFallValue(isFall) {
    return (
      <Translation>
        {(t, { i18n }) => {
          if (isFall) {
            return t("ModuleClasses.SemesterFall");
          }
          return t("ModuleClasses.SemesterSpring");
        }}
      </Translation>
    );
  }
}

export default withTranslation()(ModuleClasses);
